import React from "react";
import Skeleton from "@material-ui/lab/Skeleton/Skeleton";
import Grid from "@material-ui/core/Grid/Grid";

export const GridSkeleton = (props) => (
    <React.Fragment>
        <Grid container spacing={2} style={{height:"67vh",overflow:'auto',padding:'10px 10px 10px 20px'}}>
            <Grid item xs={6} md={4} lg={!!props.gridy ? 3 : 4}>
                <Skeleton style ={props.style}   className ={props.className}  variant="rect"  />
            </Grid>
            <Grid item xs={6} md={4} lg={!!props.gridy ? 3 : 4}>
                <Skeleton style ={props.style}  className ={props.className}   variant="rect"  />
            </Grid>
            <Grid item xs={6} md={4} lg={!!props.gridy  ? 3 : 4}>
                <Skeleton style ={props.style}  className ={props.className}   variant="rect"  />
            </Grid>
            <Grid item xs={6} md={4} lg={!!props.gridy  ? 3 : 4}>
                <Skeleton style ={props.style}  className ={props.className}   variant="rect" />
            </Grid>
            <Grid item xs={6} md={4} lg={!!props.gridy  ? 3 : 4}>
                <Skeleton style ={props.style}  className ={props.className}   variant="rect"  />
            </Grid>
            <Grid item xs={6} md={4} lg={!!props.gridy  ? 3 : 4}>
                <Skeleton style ={props.style}  className ={props.className}   variant="rect" />
            </Grid>
            {
                !!props.gridy &&
                <>
                    <Grid item xs={6} md={4} lg={!!props.gridy  ? 3 : 4}>
                        <Skeleton style ={props.style}  className ={props.className}   variant="rect"  />
                    </Grid>
                    <Grid item xs={6} md={4} lg={!!props.gridy  ? 3 : 4}>
                        <Skeleton style ={props.style}  className ={props.className}   variant="rect" />
                    </Grid>

                </>
            }

        </Grid>
    </React.Fragment>

)